import { logErrorResponseEvent } from './eventLogger';
import { callFandomServiceFactory, callFandomServiceWithBodyFactory, callFandomServiceWithFormDataFactory, } from 'utils/CallFandomServiceFactory';
export const callFandomService = callFandomServiceFactory(logErrorResponseEvent);
export const callFandomServiceWithFormData = callFandomServiceWithFormDataFactory(logErrorResponseEvent);
export const callFandomServiceWithBody = callFandomServiceWithBodyFactory(logErrorResponseEvent);
